module.exports = __webpack_public_path__ + "img/10.489b7e57.gif";